export { LegoV2 } from './LegoV2';
import { useExternalDependenceValues, useLegoElementError, useLegoElementValue, useLegoV2Context } from './hooks';
export { LegoControllerRxjs } from './controller';
export { LegoV2Context } from './context';
export { LEGO_V2_ELEMENTS } from './_Elements';
export const LegoV2Hooks = {
  /**
   *  Хук для подписки на изменения внешних зависимостей
   *  `id` - это уникальный id lego элемента
   *  `externalDependenceList` - список ключей у объекта с внешними зависимостями на которые вы подписываетесь
   */
  useExternalDependenceValues,

  /**
   *  Хук для синхронизации значения с контроллером
   *  Основной хук для работы lego элементов
   *  id - уникальный идентификатор для lego элемента
   */
  useLegoElementError,

  /**
   *  Хук для синхронизации значения с контроллером
   *  Основной хук для работы lego элементов
   *  id - уникальный идентификатор для lego элемента
   */
  useLegoElementValue,

  /** Общий контекст лего */
  useLegoV2Context,
};

export type { TLegoV2Element, TLegoElementProps as TLegoV2ElementProps } from './models';
